import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Divider } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Folder } from '@material-ui/icons';
import Checkbox from '@material-ui/core/Checkbox';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import Chip from '@material-ui/core/Chip';

const styles = theme => ({
  folderIcon: {
    minWidth: 0,
  },
  item: {
    justifyContent: 'space-between',
  },
  itemWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemText: {
    padding: theme.spacing(1, 0),
  },
  itemIconWrapper: {
    marginRight: theme.spacing(2),
  },
});

const FileItem = ({
  classes,
  onClick,
  fileCount,
  label,
  link,
  checked,
  isFolder,
}) => {
  return (
    <>
      <ListItem
        className={classes.item}
        button
        onClick={onClick}
      >
        <div className={classes.itemWrapper}>
          {isFolder ? (
            <div className={classes.itemIconWrapper}>
              <ListItemIcon className={classes.folderIcon}>
                <Folder />
              </ListItemIcon>
              {fileCount
                ? <Chip size="small" label={fileCount} />
                : undefined
              }
            </div>
          ) : undefined}
          <ListItemText
            className={classes.itemText}
            primary={
              link ? (
                <a
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={e => {
                    e.stopPropagation();
                  }}
                >
                  <Text variant="h6" weight="book" align="left">
                    {label}
                  </Text>
                </a>
              ) : (
                <Text variant="h6" weight="book" align="left">
                  {label}
                </Text>
              )
            }
          />
        </div>
        {isFolder ? undefined : (
          <Checkbox edge="end" checked={checked} />
        )}
      </ListItem>
      <Divider />
    </>
  );
};

FileItem.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  isFolder: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  fileCount: PropTypes.string,
  checked: PropTypes.bool,
  link: PropTypes.string,
};

FileItem.defaultProps = {
  fileCount: undefined,
  checked: false,
  link: undefined,
};

export default withStyles(styles)(FileItem);
